import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=826f389a&scoped=true"
import script from "./TenantSelector.vue?vue&type=script&lang=js"
export * from "./TenantSelector.vue?vue&type=script&lang=js"
import style0 from "./TenantSelector.vue?vue&type=style&index=0&id=826f389a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f389a",
  null
  
)

export default component.exports